import Vue from 'vue'

Vue.filter('notlastelement', (value, lenght, sep = ', ') =>
  value < lenght - 1 ? sep : ''
)
